import { render, staticRenderFns } from "./portfolio_risk.vue?vue&type=template&id=765a09a3&scoped=true&"
import script from "./portfolio_risk.vue?vue&type=script&lang=js&"
export * from "./portfolio_risk.vue?vue&type=script&lang=js&"
import style0 from "./portfolio_risk.vue?vue&type=style&index=0&id=765a09a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765a09a3",
  null
  
)

export default component.exports